import type { WorldCupGroupPlace } from '@wc26-forecast/model/types';

export const GROUP_PLACES = [ 1, 2, 3, 4 ] as const satisfies readonly WorldCupGroupPlace[];
export const GROUP_SELECTABLE_PLACES = [ 1, 2, 3 ] as const satisfies readonly WorldCupGroupPlace[];
